import * as t from 'io-ts';

import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import {makeEnumRuntimeType, makeIdRefType, RChannelIdRef} from './apiTypes';
import {parseCalendarEventVersionReminder, RCalendarEventVersionReminder} from './calendarEventVersionModel';

/*
 * Runtime type.
 */

export enum CalendarVersionAccessRolesEnum {
  FREE_BUSY = 'free-busy',
  READER = 'reader',
  WRITER = 'writer',
  OWNER = 'owner',
  INHERIT = 'inherit',
}

const RCalendarVersionDirty = t.readonly(
  t.type({
    id: t.Integer,
    url: t.string,
    calendarId: t.Integer,
    channelId: t.union([RChannelIdRef, t.undefined]),
    accessRole: makeEnumRuntimeType(CalendarVersionAccessRolesEnum),
    isSelected: t.boolean,
    isPrimary: t.boolean,
    isHidden: t.boolean,
    nameOverride: t.union([t.string, t.undefined]),
    reminders: t.readonlyArray(RCalendarEventVersionReminder),
    color: makeEnumRuntimeType(PaletteColorsEnum),
    updatedAt: t.Integer,
  }),
  'calendarVersion',
);

/*
 * Type.
 */

export interface CalendarVersionModel extends t.TypeOf<typeof RCalendarVersionDirty> {}
export const RCalendarVersion = t.clean<CalendarVersionModel>(RCalendarVersionDirty as any);

export const RCalendarVersionIdRef = makeIdRefType(RCalendarVersion);

/*
 * IO methods.
 */

export function parseCalendarVersion(src: any): CalendarVersionModel {
  return {
    id: src.id,
    url: src.url,
    calendarId: src.calendar.id,
    channelId: src.channel_id || undefined,
    accessRole: src.access_role,
    isSelected: src.selected,
    isPrimary: src.primary,
    isHidden: Boolean(src.hidden),
    nameOverride: src.name_override || undefined,
    reminders: src.reminders.map(parseCalendarEventVersionReminder),
    color: src.color,
    updatedAt: src.updated_at,
  };
}
